export default "__VITE_ASSET__BHbAw9n$__"